import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/common/main.scss'
import '@/utils/request'

import App from './App.vue'
import router from './router'
import store from './store'
import Components from './components'

Vue.use(ElementUI)
Vue.use(Components)
Vue.config.productionTip = false

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.handled) {
    event.preventDefault()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
